import React from "react";
import classNames from "classnames";

export function CompositeTask({task, subtasks, index, shadow}) {

    const classes = classNames("my-4  w-100", {
        "shadow":shadow,
        "border":shadow,
        "p-3":shadow,
        "p-0":!shadow,
        "pb-3":!shadow
    })


    return (
        <div className={"d-flex justify-content-center border-top"}  >
            <div className={classes} >
                <h5 className={"fw-bold  px-3 mt-2"}>Oppgave {index}</h5>
                <div className={"mt-4 px-3 fw-light"}>
                    {
                        task
                    }
                </div>

                <div className={"mt-4"}>
                    <div className={"px-3"}>
                        {
                            subtasks
                        }
                    </div>

                </div>

            </div>

        </div>
    );

}